/* tslint:disable */
/* eslint-disable */
/**
 * NLBS SDPS Secure Zone API
 * NLBS SDPS Secure Zone API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckPsuResponseBody
 */
export interface CheckPsuResponseBody {
    /**
     * 
     * @type {number}
     * @memberof CheckPsuResponseBody
     */
    aipsFailed: number;
    /**
     * 
     * @type {number}
     * @memberof CheckPsuResponseBody
     */
    aipsRejected: number;
    /**
     * 
     * @type {number}
     * @memberof CheckPsuResponseBody
     */
    aipsStored: number;
    /**
     * 
     * @type {number}
     * @memberof CheckPsuResponseBody
     */
    dipsFailed: number;
    /**
     * 
     * @type {number}
     * @memberof CheckPsuResponseBody
     */
    dipsRejected: number;
    /**
     * 
     * @type {number}
     * @memberof CheckPsuResponseBody
     */
    dipsStored: number;
    /**
     * 
     * @type {Date}
     * @memberof CheckPsuResponseBody
     */
    lastPsuRequestedAt: Date;
}

/**
 * Check if a given object implements the CheckPsuResponseBody interface.
 */
export function instanceOfCheckPsuResponseBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "aipsFailed" in value;
    isInstance = isInstance && "aipsRejected" in value;
    isInstance = isInstance && "aipsStored" in value;
    isInstance = isInstance && "dipsFailed" in value;
    isInstance = isInstance && "dipsRejected" in value;
    isInstance = isInstance && "dipsStored" in value;
    isInstance = isInstance && "lastPsuRequestedAt" in value;

    return isInstance;
}

export function CheckPsuResponseBodyFromJSON(json: any): CheckPsuResponseBody {
    return CheckPsuResponseBodyFromJSONTyped(json, false);
}

export function CheckPsuResponseBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckPsuResponseBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'aipsFailed': json['aips_failed'],
        'aipsRejected': json['aips_rejected'],
        'aipsStored': json['aips_stored'],
        'dipsFailed': json['dips_failed'],
        'dipsRejected': json['dips_rejected'],
        'dipsStored': json['dips_stored'],
        'lastPsuRequestedAt': (new Date(json['last_psu_requested_at'])),
    };
}

export function CheckPsuResponseBodyToJSON(value?: CheckPsuResponseBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'aips_failed': value.aipsFailed,
        'aips_rejected': value.aipsRejected,
        'aips_stored': value.aipsStored,
        'dips_failed': value.dipsFailed,
        'dips_rejected': value.dipsRejected,
        'dips_stored': value.dipsStored,
        'last_psu_requested_at': (value.lastPsuRequestedAt.toISOString()),
    };
}

